module.exports = __webpack_public_path__ + "img/header-diamondJewelryPresentsMother@2x.796931a.webp";